import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import MetricSection from '/component/partial/MetricSection';
import {PeopleToContact} from '/component/partial/PeopleToContact';
import {MetricsSection} from '/constant/TestIDs';

import {usePeopleToContactSection} from './PeopleToContactSection.hook';
import {styles} from './PeopleToContactSection.style';
interface PeopleToContactSectionProps {
  onOpenModal: () => void;
  onShowReport: () => void;
  onShowInfoPopover: () => void;
  clientsToContactNumberForCurrentTab: number | null;
  parentScreenName: string;
  featureFlag: Record<string, any>;
}

export const PeopleToContactSection: React.FC<PeopleToContactSectionProps> = ({
  onOpenModal = noop,
  onShowReport = noop,
  onShowInfoPopover = noop,
  clientsToContactNumberForCurrentTab: clientsNumber = null,
  parentScreenName = '',
  featureFlag = {},
}) => {
  const {ts, onInfoPress, onItemPress, height, onShowProfile} =
    usePeopleToContactSection({
      onShowInfoPopover,
      onShowReport,
      clientsNumber,
      onOpenModal,
      featureFlag,
    });
  // The swipeEnabled was false because there are no good event listeners for the swipe yet
  return (
    <>
      <MetricSection
        analyticsTitle="People to Contact"
        infoAccessibilityLabel={ts(
          'accessibilityLabel',
          'People to Contact Section Information button',
        )}
        title={ts('heading', 'People to Contact')}
        onInfoPress={onInfoPress}
        containerStyle={styles.metricSectionContainer}
        headerStyle={styles.metricSectionHeader}
        accessible={true}
        testID={MetricsSection.metricSectionClientsToContact}
        accessibilityLabel="People to Contact Section"
      />
      {/*  --- Qualtrics survey temporarily disabled for accessibility compliance ---
      <FeatureFeedback
        style={{base: styles.featureFeedback}}
        parentScreenName={parentScreenName}
      /> */}
      <View style={[{height}]}>
        <PeopleToContact
          onShowProfile={onShowProfile}
          onShowReport={onItemPress}
          parentScreenName={parentScreenName}
          swipeEnabled={false}
          reportDefaultLoadingCount={3}
          showFullReport={false}
        />
      </View>
    </>
  );
};
